import useSWR from "swr";
import { apiBaseURL } from "../../Utils/ProjectConstants";

export default function useGetAllTimeOffs() {
  const { data, error, mutate, isLoading } = useSWR(
    `${apiBaseURL}/api/user/timeoffs/all`,
    {
      onSuccess: (data) =>
        console.log("Get all current PTOs fetched successfully:", data?.data),
      revalidateOnFocus: false,
      dedupingInterval: 300000,
    },
  );
  const timeOffs = data?.data;
  return {
    timeOffs,
    error,
    mutate,
    isLoading,
  };
}
